module.exports = __webpack_public_path__ + "img/part5-21.463bbd79.png";